import Vue from 'vue'
import App from './App.vue'
import './scss/reset.scss'
import VueTippy, { TippyComponent } from "vue-tippy";
import './scss/fonts.scss'
import Vuelidate from "vuelidate/src";
import router from "./router";
// eslint-disable-next-line no-unused-vars
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect

import 'sweetalert2/dist/sweetalert2.min.css';
import "tippy.js/themes/light.css";

Vue.use(Vuelidate);
Vue.use(VueTippy);
Vue.use(VueSweetalert2);
Vue.use(router);
Vue.config.productionTip = false;
Vue.component("tippy", TippyComponent);

new Vue({
  render: h => h(App),
  validations:{},
  router
}).$mount('#app');
